import {
  ReadyLoopClient,
  buildContent,
  createTurn,
  decodeJwtPayload,
  detectApiUrl,
  fetchConfig,
  fetchSbaaConfig,
  isTokenExpired,
  openDrivePicker,
  openGoogleOAuthPopup,
  parseSSE,
  processEvent,
  replayConversation
} from "./chunk-HYS6OK27.js";

// src/core/format.ts
var CREDIT_VALUE_USD = 5e-3;
function formatTokenCount(n) {
  if (n < 1e3) return String(n);
  const k = Math.round(n / 1e3);
  return `${k}k`;
}
function formatCredits(costUsd) {
  if (costUsd <= 0) return "";
  const cr = Math.max(0.1, Math.round(costUsd / CREDIT_VALUE_USD * 10) / 10);
  if (cr === Math.floor(cr)) return `${cr} cr`;
  return `${cr.toFixed(1)} cr`;
}
function formatTokenUsage(usage, creditsUsed) {
  var _a, _b, _c, _d;
  const inp = (_a = usage.input_tokens) != null ? _a : 0;
  const cacheRead = (_b = usage.cache_read_input_tokens) != null ? _b : 0;
  const cacheCreate = (_c = usage.cache_creation_input_tokens) != null ? _c : 0;
  const out = (_d = usage.output_tokens) != null ? _d : 0;
  if (!inp && !cacheRead && !cacheCreate && !out && !creditsUsed) return "";
  const parts = [];
  const inStr = formatTokenCount(inp);
  const cacheParts = [];
  if (cacheRead) cacheParts.push(`${formatTokenCount(cacheRead)} cached`);
  if (cacheCreate) cacheParts.push(`${formatTokenCount(cacheCreate)} cache-write`);
  if (cacheParts.length) {
    parts.push(`${inStr} in (${cacheParts.join(", ")})`);
  } else {
    parts.push(`${inStr} in`);
  }
  parts.push(`-> ${formatTokenCount(out)} out`);
  let result = parts.join(" ");
  if (creditsUsed != null && creditsUsed > 0) {
    result += ` . ${creditsUsed} cr`;
  }
  return result;
}
export {
  ReadyLoopClient,
  buildContent,
  createTurn,
  decodeJwtPayload,
  detectApiUrl,
  fetchConfig,
  fetchSbaaConfig,
  formatCredits,
  formatTokenCount,
  formatTokenUsage,
  isTokenExpired,
  openDrivePicker,
  openGoogleOAuthPopup,
  parseSSE,
  processEvent,
  replayConversation
};
